var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cart_items" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "cart_item",
        _vm._b(
          {
            key: item.key,
            attrs: {
              this_key: item.key,
              points: item.points,
              variant_metafields: item.variant_metafields,
              is_new: item.customAttributes && item.customAttributes.new,
              is_hidden: item.dont_render_anchors,
              show_variant_info:
                !item.product_has_only_default_variant && !item.gift_card,
              limit: "5",
            },
          },
          "cart_item",
          item,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }